import { useEffect, useState } from "react";
import { Link } from "react-router";
import { LOT_STATUS_LABELS, type AdminChatThread } from "@omts/shared";
import { adminApi, subscribeEvents } from "../../api";
import { fmtDateTime } from "../../time";
import { statusBadgeClass } from "../LotsPage";
import { useList } from "./common";

/** Сводный список чатов по всем лотам (15.2.4): лот, компания, последнее сообщение, непрочитанные; поиск по лоту/компании. */
export function ChatsTab() {
  const { items, error, reload } = useList<AdminChatThread>(adminApi.chats);
  const [q, setQ] = useState("");

  useEffect(
    () =>
      subscribeEvents((type) => {
        if (type === "chat.message" || type === "chat.read") reload();
      }),
    [reload],
  );

  const needle = q.trim().toLowerCase();
  const rows = (items ?? []).filter((t) => !needle || t.lotNumber.toLowerCase().includes(needle) || t.companyName.toLowerCase().includes(needle));
  const unreadTotal = (items ?? []).reduce((s, t) => s + t.unreadCount, 0);

  return (
    <>
      <div className="toolbar">
        <input placeholder="Поиск по номеру заявки или компании" value={q} onChange={(e) => setQ(e.target.value)} />
        <span className="muted">
          {items ? `${items.length} переписок` : ""}
          {unreadTotal > 0 && <span className="overdue-count"> · {unreadTotal} непрочитанных</span>}
        </span>
      </div>
      {error && <p className="error">{error}</p>}
      <section className="card">
        {!items ? (
          <p className="muted">Загрузка…</p>
        ) : rows.length === 0 ? (
          <p className="muted">{items.length === 0 ? "Переписок с перевозчиками пока не было." : "Ничего не найдено."}</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Заявка</th>
                <th>Компания</th>
                <th>Последнее сообщение</th>
                <th>Когда</th>
                <th>Сообщений</th>
                <th>Непрочитанных</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((t) => (
                <tr key={`${t.lotId}:${t.companyId}`} className={t.unreadCount > 0 ? "has-unread" : ""}>
                  <td className="nowrap">
                    <Link to={`/lots/${t.lotId}`} className="lot-link">
                      <b>{t.lotNumber}</b>
                    </Link>
                    <div>
                      <span className={`badge ${statusBadgeClass(t.lotStatus)}`}>{LOT_STATUS_LABELS[t.lotStatus]}</span>
                    </div>
                  </td>
                  <td>{t.companyName}</td>
                  <td className="chat-last">
                    <span className="text" title={t.lastMessage.text}>
                      <span className="muted">{t.lastMessage.direction === "carrier" ? "перевозчик: " : "логист: "}</span>
                      {t.lastMessage.text}
                    </span>
                  </td>
                  <td className="nowrap muted">{fmtDateTime(t.lastMessage.createdAt)}</td>
                  <td className="mono">{t.messagesCount}</td>
                  <td className="mono">{t.unreadCount > 0 ? <b className="overdue-count">{t.unreadCount}</b> : <span className="muted">0</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
      <p className="hint">Переписка ведётся в карточке лота (блок «Чат с перевозчиками»); здесь — только сводка по всем заявкам.</p>
    </>
  );
}
